import { PencilIcon, PlusIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';
import ROUTE_PATHS from '../../../routes/paths';

interface ManageOptionSummaryButtonProps {
  disabled?: boolean;
}

const ManageOptionSummaryButton: React.FC<ManageOptionSummaryButtonProps> = ({
  disabled,
}) => {
  const { currentOption } = useAppointmentProposalOptions();

  if (!currentOption) {
    return null;
  }

  const isReadOnly = currentOption.isReadOnly;

  return (
    <Button
      component={Link}
      to={ROUTE_PATHS.PROPOSAL_OPTIONS_PATH({
        appointmentId: currentOption.appointmentId,
        appointmentProposalId: currentOption.appointmentProposalId,
        appointmentProposalOptionId: currentOption.appointmentProposalOptionId,
        extraPath: 'summary',
      })}
      color="softGold"
      startIcon={currentOption.summary ? <PencilIcon /> : <PlusIcon />}
      disabled={disabled || isReadOnly}
    >
      {currentOption.summary ? 'Edit summary' : 'Add summary'}
    </Button>
  );
};

export default ManageOptionSummaryButton;
